import apiClient from "../apis/api";
import axios from "axios";

const uploadFile = async (file, folderStrucuture, onProgress) => {
  if (!file) {
    console.error("No file provided for upload.");
    return null;
  }

  try {
    // Step 1: Request signed URL from backend
    const backendRes = await apiClient.post("/upload/generate-upload-url", {
      fileName: file.name,
      fileType: file.type,
      folderStrucuture: folderStrucuture,
    });

    const { uploadUrl, fileUrl } = backendRes;

    // Step 2: Upload file directly to S3 using the signed URL
    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": file.type,
        "Content-Disposition": `attachment; filename="${file.name}"`,
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });

    // Step 3: Return the public S3 file URL
    return fileUrl;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export default uploadFile;

// import {
//   S3Client,
//   CreateMultipartUploadCommand,
//   UploadPartCommand,
//   CompleteMultipartUploadCommand,
//   AbortMultipartUploadCommand,
//   CopyObjectCommand,
// } from "@aws-sdk/client-s3";

// const {
//   REACT_APP_S3_ACCESS_KEY_ID,
//   REACT_APP_S3_SECRET_ACCESS_KEY,
//   REACT_APP_S3_BUCKET_NAME,
//   REACT_APP_S3_REGION,
// } = process.env;

// const s3Client = new S3Client({
//   region: REACT_APP_S3_REGION,
//   credentials: {
//     accessKeyId: REACT_APP_S3_ACCESS_KEY_ID,
//     secretAccessKey: REACT_APP_S3_SECRET_ACCESS_KEY,
//   },
// });

// const uploadFile = async (file, onProgress) => {
//   if (!file) {
//     console.error("No file provided for upload.");
//     return null;
//   }

//   const chunkSize = 10 * 1024 * 1024; // 10MB per chunk
//   const totalParts = Math.ceil(file.size / chunkSize);
//   const uniqueFileName = `${crypto.randomUUID()}-${file.name}`;

//   let uploadId;
//   let uploadedSize = 0;
//   let currentProgress = 0;
//   let progressInterval;

//   try {
//     // **Step 1: Initialize Multipart Upload**
//     const createResponse = await s3Client.send(
//       new CreateMultipartUploadCommand({
//         Bucket: REACT_APP_S3_BUCKET_NAME,
//         Key: uniqueFileName,
//         ContentType: file.type,
//       })
//     );

//     uploadId = createResponse.UploadId;

//     let uploadedParts = [];

//     // **Simulate Smooth Progress Updates**
//     if (onProgress) {
//       progressInterval = setInterval(() => {
//         if (currentProgress < 95) {
//           currentProgress += Math.min(2, 95 - currentProgress);
//           onProgress(Math.round(currentProgress));
//         }
//       }, 800);
//     }

//     // **Step 2: Upload Parts in Parallel**
//     const uploadPromises = Array.from(
//       { length: totalParts },
//       async (_, index) => {
//         const partNumber = index + 1;
//         const start = index * chunkSize;
//         const end = Math.min(start + chunkSize, file.size);
//         const chunk = file.slice(start, end);

//         // Convert Blob to Uint8Array
//         const arrayBuffer = await chunk.arrayBuffer();
//         const uint8Array = new Uint8Array(arrayBuffer);

//         const uploadResponse = await s3Client.send(
//           new UploadPartCommand({
//             Bucket: REACT_APP_S3_BUCKET_NAME,
//             Key: uniqueFileName,
//             UploadId: uploadId,
//             PartNumber: partNumber,
//             Body: uint8Array,
//           })
//         );

//         uploadedParts.push({
//           ETag: uploadResponse.ETag,
//           PartNumber: partNumber,
//         });

//         uploadedSize += chunk.size;
//         currentProgress = Math.max(
//           currentProgress,
//           Math.round((uploadedSize / file.size) * 100)
//         );
//         if (onProgress) onProgress(currentProgress);
//       }
//     );

//     await Promise.all(uploadPromises);

//     // **Step 3: Sort Parts Before Completing Upload**
//     uploadedParts.sort((a, b) => a.PartNumber - b.PartNumber);

//     // **Step 4: Complete Multipart Upload**
//     await s3Client.send(
//       new CompleteMultipartUploadCommand({
//         Bucket: REACT_APP_S3_BUCKET_NAME,
//         Key: uniqueFileName,
//         UploadId: uploadId,
//         MultipartUpload: { Parts: uploadedParts },
//       })
//     );

//     if (onProgress) onProgress(100);

//     // **Step 5: Apply Metadata Using CopyObjectCommand**
//     await s3Client.send(
//       new CopyObjectCommand({
//         Bucket: REACT_APP_S3_BUCKET_NAME,
//         CopySource: `${REACT_APP_S3_BUCKET_NAME}/${uniqueFileName}`,
//         Key: uniqueFileName,
//         MetadataDirective: "REPLACE", // 🔥 Important: This ensures metadata is applied
//         Metadata: {
//           "Content-Disposition": `attachment; filename="${file.name}"`, // Forces download
//         },
//       })
//     );

//     // Clear progress interval
//     clearInterval(progressInterval);

//     return `https://${REACT_APP_S3_BUCKET_NAME}.s3.${REACT_APP_S3_REGION}.amazonaws.com/${uniqueFileName}`;
//   } catch (error) {
//     console.error("S3 Multipart Upload Error:", error);

//     if (uploadId) {
//       await s3Client.send(
//         new AbortMultipartUploadCommand({
//           Bucket: REACT_APP_S3_BUCKET_NAME,
//           Key: uniqueFileName,
//           UploadId: uploadId,
//         })
//       );
//       console.log("Multipart upload aborted due to error.");
//     }

//     clearInterval(progressInterval);
//     return null;
//   }
// };

// export default uploadFile;
